import { render, staticRenderFns } from "./TourLeaders.vue?vue&type=template&id=0b64fea8&"
import script from "./TourLeaders.vue?vue&type=script&lang=js&"
export * from "./TourLeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports